export default "__VITE_ASSET__wZTocF23__"